import { useMemo, useState } from 'react';
import { logoPrincipal } from '../assets';
import LegalModal from './LegalModal';

export default function Footer() {
  const [legalOpen, setLegalOpen] = useState(false);
  const [legalView, setLegalView] = useState(null); // 'privacy' | 'terms' | 'cookies'

  const openLegal = (view) => {
    setLegalView(view);
    setLegalOpen(true);
  };

  const closeLegal = () => {
    setLegalOpen(false);
    setLegalView(null);
  };

  const legalContent = useMemo(() => {
    if (legalView === 'privacy') {
      return {
        title: 'Política de Privacidad',
        body: (
          <>
            <p>En Next Global Media respetamos tu privacidad y protegemos tu información personal.</p>

            <h4>Información que recopilamos:</h4>
            <ul>
              <li>Nombre</li>
              <li>Correo electrónico</li>
              <li>Número de teléfono</li>
              <li>Información enviada a través de formularios</li>
            </ul>

            <h4>Uso de la información</h4>
            <p>Utilizamos tus datos para:</p>
            <ul>
              <li>Contactarte</li>
              <li>Brindarte información sobre nuestros servicios</li>
              <li>Enviarte ofertas o contenido relacionado (si aplica)</li>
            </ul>

            <p>No vendemos, alquilamos ni compartimos tu información con terceros.</p>

            <h4>Herramientas</h4>
            <p>Podemos utilizar herramientas como:</p>
            <ul>
              <li>Google Analytics</li>
              <li>Meta (Facebook/Instagram Ads)</li>
              <li>Plataformas de automatización</li>
            </ul>

            <p>Estas herramientas pueden recopilar datos anónimos para mejorar la experiencia del usuario.</p>
            <p>Al usar este sitio, aceptas esta política de privacidad.</p>
          </>
        ),
      };
    }

    if (legalView === 'terms') {
      return {
        title: 'Términos y Condiciones',
        body: (
          <>
            <p>Al acceder a este sitio web, aceptas cumplir con los siguientes términos:</p>
            <ul>
              <li>El contenido del sitio es propiedad de Next Global Media</li>
              <li>No está permitido copiar, distribuir o reproducir el contenido sin autorización</li>
              <li>Los servicios ofrecidos están sujetos a acuerdos específicos con cada cliente</li>
              <li>Los resultados pueden variar según el proyecto y factores externos</li>
            </ul>

            <h4>Next Global Media no se responsabiliza por:</h4>
            <ul>
              <li>Decisiones tomadas basadas en la información del sitio</li>
              <li>Problemas técnicos fuera de nuestro control</li>
            </ul>

            <p>Nos reservamos el derecho de modificar estos términos en cualquier momento.</p>
          </>
        ),
      };
    }

    if (legalView === 'cookies') {
      return {
        title: 'Política de Cookies',
        body: (
          <>
            <p>Este sitio web utiliza cookies para mejorar tu experiencia.</p>

            <p>Las cookies son pequeños archivos que se almacenan en tu dispositivo y permiten:</p>
            <ul>
              <li>Analizar el comportamiento del usuario</li>
              <li>Mejorar el rendimiento del sitio</li>
              <li>Mostrar contenido personalizado</li>
            </ul>

            <h4>Utilizamos herramientas como:</h4>
            <ul>
              <li>Google Analytics</li>
              <li>Pixel de Meta</li>
            </ul>

            <p>Puedes aceptar, rechazar o eliminar las cookies desde la configuración de tu navegador.</p>
            <p>Al continuar navegando en este sitio, aceptas el uso de cookies.</p>
          </>
        ),
      };
    }

    // (opcional) Aviso legal como fallback (si legalView es null)
    return {
      title: 'Aviso Legal',
      body: (
        <>
          <p>
            Next Global Media es una agencia de marketing digital enfocada en ofrecer servicios de branding, desarrollo
            web, marketing digital, automatización e inteligencia artificial.
          </p>

          <p>Al acceder y utilizar este sitio web, aceptas las condiciones aquí descritas.</p>

          <p>
            La información proporcionada en este sitio tiene fines informativos y comerciales. Next Global Media no
            garantiza resultados específicos, ya que estos pueden variar según cada proyecto, mercado y ejecución.
          </p>

          <p>Nos reservamos el derecho de modificar el contenido del sitio en cualquier momento sin previo aviso.</p>

          <h4>Contacto</h4>
          <ul>
            <li>📧 Nataly@nextglobalmedia.com</li>
            <li>📍 New York, United States</li>
          </ul>
        </>
      ),
    };
  }, [legalView]);

  return (
    <footer
      className="
        py-24 border-t border-orange-500
        bg-[#000000]/80 dark:bg-[#000000]/80
        backdrop-blur-md
        relative overflow-hidden
      "
    >
      {/* ✅ BACKGROUND logoPrincipal centrado y a todo el ancho (más visible) */}
      <div className="absolute inset-0 pointer-events-none z-0 flex items-center justify-center">
        <img
          src={logoPrincipal}
          alt=""
          className="
            w-[1200px] max-w-[140vw] h-auto
            opacity-[0.14] dark:opacity-[0.18]
            object-contain
          "
          style={{ filter: 'grayscale(1) contrast(1.25)' }}
        />
      </div>

      {/* ✅ overlay */}
      <div className="absolute inset-0 pointer-events-none z-0 bg-black/20 dark:bg-black/20" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-20 mb-20">
          <div className="col-span-1 md:col-span-2">
            <img alt="Next Global Media Full Logo" className="h-14 mb-10 mix-blend-multiply" src={logoPrincipal} />

            <p className="text-slate-600 dark:text-slate-300 max-w-sm mb-12 text-lg font-light leading-relaxed">
              Hacemos que tu marca avance con estrategia, creatividad y tecnología. Nuestro objetivo es que tu negocio
              crezca, destaque y llegue más lejos.
            </p>

            {/* ICONOS SOCIALES (los que ya dejaste) */}
            <div className="flex gap-6">
              {/* Facebook */}
              <a
                className="w-12 h-12 rounded-2xl glass-card bg-slate-300/90 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-all border border-slate-200 group text-[#1877F2]"
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                title="Facebook"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>

              {/* WhatsApp */}
              <a
                className="w-12 h-12 rounded-2xl glass-card bg-slate-300/90 flex items-center justify-center hover:bg-green-500 hover:text-white transition-all border border-slate-200 group text-[#25D366]"
                href="https://wa.me/19145071839"
                target="_blank"
                rel="noopener noreferrer"
                title="WhatsApp"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.67-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.076 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347" />
                </svg>
              </a>

              {/* YouTube */}
              <a
                className="w-12 h-12 rounded-2xl glass-card bg-slate-300/90 flex items-center justify-center hover:bg-red-600 hover:text-white transition-all border border-slate-200 group text-[#FF0000]"
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                title="YouTube"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
              </a>

              {/* TikTok */}
              <a
                className="w-12 h-12 rounded-2xl glass-card bg-slate-300/90 flex items-center justify-center hover:bg-pink-500 hover:text-white transition-all border border-slate-200 group text-[#696969]"
                href="https://tiktok.com"
                target="_blank"
                rel="noopener noreferrer"
                title="TikTok"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 5.2-1.74V9.4a6.84 6.84 0 0 0-1-.118 6.852 6.852 0 0 0-6.852 6.852A6.852 6.852 0 0 0 12.06 22.8a6.844 6.844 0 0 0 6.852-6.852v-3.29a4.828 4.828 0 0 0 3.077 1.18v-3.45a4.83 4.83 0 0 1-2.4-.677z" />
                </svg>
              </a>

              {/* Instagram */}
              <a
                className="w-12 h-12 rounded-2xl glass-card bg-slate-300/90 flex items-center justify-center hover:bg-pink-500 hover:text-white transition-all border border-slate-200 group text-[#E1306C]"
                href="https://www.instagram.com/nextglobalmedia.us?igsh=eDcxNWJybmFvczZn&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                title="Instagram"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7.8 2h8.4A5.8 5.8 0 0 1 22 7.8v8.4A5.8 5.8 0 0 1 16.2 22H7.8A5.8 5.8 0 0 1 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2Zm-.2 2A3.6 3.6 0 0 0 4 7.6v8.8A3.6 3.6 0 0 0 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6A3.6 3.6 0 0 0 16.4 4H7.6Zm10.65 1.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z" />
                </svg>
              </a>
            </div>
          </div>

          <div>
            <h5 className="font-black text-orange-500 mb-10 tracking-[0.3em] uppercase text-xs">Agencia</h5>
            <ul className="space-y-6 text-slate-600 dark:text-slate-100 text-sm font-bold">
              <li>
                <a className="hover:text-orange-500 transition-colors uppercase tracking-widest" href="#portfolio">
                  Galería
                </a>
              </li>
              <li>
                <a className="hover:text-orange-500 transition-colors uppercase tracking-widest" href="#services">
                  Servicios
                </a>
              </li>
              <li>
                <a className="hover:text-orange-500 transition-colors uppercase tracking-widest" href="#process">
                  Estrategia
                </a>
              </li>
              <li>
                <a className="hover:text-orange-500 transition-colors uppercase tracking-widest" href="#team">
                  Lab
                </a>
              </li>
            </ul>
          </div>

          {/* ✅ LEGAL -> botones abren modal */}
          <div>
            <h5 className="font-black text-orange-500 mb-10 tracking-[0.3em] uppercase text-xs">Legal</h5>
            <ul className="space-y-6 text-slate-300 text-sm font-bold">
              <li>
                <button
                  type="button"
                  onClick={() => openLegal('privacy')}
                  className="hover:text-orange-500 transition-colors uppercase tracking-widest"
                >
                  Privacidad
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => openLegal('terms')}
                  className="hover:text-orange-500 transition-colors uppercase tracking-widest"
                >
                  Términos
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => openLegal('cookies')}
                  className="hover:text-orange-500 transition-colors uppercase tracking-widest"
                >
                  Cookies
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-12 border-t border-orange-500">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
            <div className="text-center md:text-left">
              <p className="text-sm text-slate-600 dark:text-slate-100 font-light tracking-wide">
                2024 NEXT GLOBAL MEDIA. ALL RIGHTS RESERVED.
              </p>
            </div>
          </div>
        </div>
      </div>

      <LegalModal open={legalOpen} title={legalContent.title} onClose={closeLegal}>
        {legalContent.body}
      </LegalModal>
    </footer>
  );
}